// ─────────────────────────────────────────────────────────────────────────────
// useAdminRoles — fetches the role definitions for the Admin Roles tab.
//   GET /settings/admin-roles
// Display only (no save endpoint). The backend derives these from its RBAC
// config (config/rbac.ts) — the same matrix the API enforces — so this tab
// always reflects real access.
// ─────────────────────────────────────────────────────────────────────────────
import { useState, useEffect } from "react";
import { getAdminRoles } from "../../../services/settingsService";

export function useAdminRoles() {
  const [roles,   setRoles]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    let cancelled = false;
    getAdminRoles()
      .then(data => { if (!cancelled && data?.roles) setRoles(data.roles); })
      .catch(err => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { roles, loading, error };
}
